import { UniqueEntityID } from '@/domain/core'
import { ADHP, AwWaypoint, City, VisualPosition, WaypointProps } from '@/domain/models/Waypoint'
import { Coordinates } from '@/domain/protocols/Coordinates'

import { WaypointsFullResponseItem } from './IAeroInfoRepository'

export interface AeroInfoMapperResponse {
  ADHPs: ADHP[]
  AwWaypoints: AwWaypoint[]
  Cities: City[]
  VisualPositions: VisualPosition[]
}

export const AeroInfoMapper = (waypoints: WaypointsFullResponseItem[]): AeroInfoMapperResponse => {
  const ADHPs: ADHP[] = []
  const AwWaypoints: AwWaypoint[] = []
  const Cities: City[] = []
  const VisualPositions: VisualPosition[] = []

  for (const info of waypoints) {
    try {
      const waypointProps: WaypointProps = {
        code: info.code,
        name: info.name,
        coordinates: Coordinates.create({
          latitude: info.coordinates.latitude,
          longitude: info.coordinates.longitude,
          altitude: info.coordinates?.altitude
        }),
        createdAt: new Date(info.createdAt),
        updatedAt: new Date(info.updatedAt)
      }

      switch (info.__typename) {
        case 'ADHP':
          // Os campos pesados de `extra` nem chegam aqui: sao removidos em `trimWaypointsFull`, que
          // documenta o que sai e por que `rotaer` fica.
          //
          // Uma lista so. Antes eram DUAS (`ADHPs` enxuta + `ADHPsFull`), ou seja 12.142 entidades
          // `ADHP` para 6.071 aerodromos — o dobro de alocacao no boot, sem necessidade.
          ADHPs.push(
            ADHP.create(
              waypointProps,
              {
                type: info.extra.type,
                city: info.extra.city,
                uf: info.extra.uf,
                rotaer: info.extra.rotaer
              },
              new UniqueEntityID(info.id)
            )
          )
          break
        case 'AwWaypoint':
          AwWaypoints.push(AwWaypoint.create(waypointProps, {}, new UniqueEntityID(info.id)))
          break
        case 'City':
          Cities.push(City.create(waypointProps, {}, new UniqueEntityID(info.id)))
          break
        case 'VisualPosition':
          VisualPositions.push(
            VisualPosition.create(
              waypointProps,
              { rea: info.extra.rea, visualDesc: info.extra.visualDesc },
              new UniqueEntityID(info.id)
            )
          )
          break
      }
    } catch (error) {
      console.error(`[AeroInfoMapper] ${info}\n${error}`)
      continue
    }
  }
  return { ADHPs, AwWaypoints, Cities, VisualPositions }
}
